import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["MercadoPagoButton"] */ "/vercel/path0/src/components/mercadopago/MercadoPagoButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PayPalButton"] */ "/vercel/path0/src/components/paypal/PayPalButton.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/product/color-selector/ColorSelector.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/product/courier-selector/CourierSelector.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/product/quantity-selector/QuantitySelector.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/product/slideshow/ProductMobileSlideshow.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/product/slideshow/ProductSlideshow.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/products/product-grid/ProductGridItem.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/providers/Providers.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/ui/pagination/Pagination.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/ui/sidebar/Sidebar.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/ui/top-menu/TopMenu.tsx");
